import { Component, Input, OnInit, Optional } from '@angular/core';
import { RoleModel } from '../definition/role.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MmValidators } from 'mm-web-core/form/validators';
import { MmTranslateService } from 'mm-web-core/i18n';
import { identityConstants } from '../identity-constants';
import { onFormSubmit } from 'mm-web-core/form';
import { RoleApiService } from '../services/role-api.service';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-role-form',
  templateUrl: './role-form.component.html',
  styleUrls: ['./role-form.component.scss']
})
export class RoleFormComponent implements OnInit {

  form: FormGroup;
  constructor(
    fb: FormBuilder,
    private mmTranslateService: MmTranslateService,
    @Optional() public modalRef: NzModalRef,
    private api: RoleApiService
  ) {
    this.form = fb.group({
      name: fb.control(undefined, MmValidators.required()),
      displayName: fb.control(undefined, [MmValidators.required(), MmValidators.requiredLangs(this.mmTranslateService.supportedLangs)]),
      permissions: fb.control(undefined)

    })

  }

  model: RoleModel = <RoleModel>{}
  async ngOnInit() {

    if (this.model.id) {
      const permissions = await this.api.getPermissions(this.model.id).toPromise();
      this.model.permissions = permissions;
    }

    this.form.patchValue(this.model);


  }

  @Input()
  usePermission: boolean;

  resolveKey(key: string) {
    return `${identityConstants.transalationGroup}.${key}`
  }

  async save() {
    onFormSubmit(this.form);
    // debugger;
    if (this.form.invalid) return;

    const payload = {
      ...this.model,
      ...this.form.value
    } as RoleModel;

    if (payload.id) {
      await this.api.update(payload).toPromise();

    }
    else {
      await this.api.create(payload).toPromise();
    }
    if (this.modalRef) {
      this.modalRef.close(true);
    }


  }


}
